import lodash from 'lodash';

import {ANALYSIS, TOTAL_DETAIL} from '../containers/user/detailed-dearch/main-search/constant';
import {ACTIONS} from '../actions/detail-search'

const initialState = {
    [TOTAL_DETAIL.TYPE]: 'pitchers',
    [TOTAL_DETAIL.COLUMN_GROUP] : 1,
    [TOTAL_DETAIL.TEAM_CONDITION] : {
        team: {
            central: [],
            pacific: []
        },
        oppTeam: {
            central: [],
            pacific: []
        }
    },
    [TOTAL_DETAIL.PLAYER_CONDITION] : {
        player: [],
        oppPlayer: [],
    },
    [TOTAL_DETAIL.CATEGORY_SECTION] : {
        regularSeason: 1,
        postSeason: []
    },
    [TOTAL_DETAIL.SELECT_PERIOD] : {
        year: {
            startYear: null,
            endYear: null,
        },
        date: {
            startDate: null,
            endDate: null
        },
        allYear: false,
        monthCheck: [],
        checkAllStar: []
    },
    [TOTAL_DETAIL.TARGET_CONDITION] : {
        ruleAtBat: false,
        atBat: null,
        overBat: null,
        moreThanAPick: null
    },
    [ANALYSIS.AT_BAT] : [],
    [ANALYSIS.BALL_SPEED] : {
        min: null,
        max: null
    },
    [ANALYSIS.BATTING_ORDER] : [],
    [ANALYSIS.COUNT] : {
        oneStrike: [],
        twoStrike: [],
        threeStrike: [],
    },
    [ANALYSIS.DEFENSIVE_POSITION] : [],
    [ANALYSIS.HITTING_DIRECTION] : {
        "3div": [],
        "5div": [],
    },
    [ANALYSIS.HITTING_PROPERTY] : [],
    [ANALYSIS.INNING] : {
        oneInnings: [],
        twoInnings: [],
        threeInnings: [],
    },
    [ANALYSIS.INNING_TOP_BATTER] : [],
    [ANALYSIS.LEFT_RIGHT_BAT] : [],
    [ANALYSIS.NUMBER_OF_PITCHER_AT_BAT] : [],
    [ANALYSIS.PITCHING_COURSE] : {
        lrIds: [],
        hlIds: [],
        zoneIds: []
    },
    [ANALYSIS.PITCH_TYPE] : {
        straight: null,
        changingSphere: []
    },
    [ANALYSIS.POINT_DIFFERENCE] : {
        diffIds: [],
        score: null,
        uplow: null,
    },
    [ANALYSIS.RUNNER] : {
        none: null,
        available: []
    },
    [ANALYSIS.SCORING_RUNNER] : [],
    [ANALYSIS.STARTER_RELIEF] : []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.SET_CONDITION_DETAIL_SEARCH :
            return {
                ...state,
                ...lodash.update(state, action.body.field, () => action.body.value),
            }
        default:
            return state
    }
}
